module.exports = __webpack_public_path__ + "common/icon-link-d918aa4bb32621f2e8ebf949cc11ff0a.svg";